module.exports = __webpack_public_path__ + "static/media/finance_calculator.496f4d5d.png";